/* eslint-disable no-param-reassign */
import { DEFAULT_DYNAMICS, DEFAULT_MECHANICS } from "../data/cartesianData";

// Kinematics
export const setKinematicsImplementation = (state, action) => {
  const { configuration } = state;
  const kinematics = action.payload;

  configuration.configData.kinematics = kinematics;
};

// Mechanis
export const setMechanicsImplementation = (state, action) => {
  const { configuration } = state;
  const mechanics = action.payload;

  configuration.configData.mechanics = mechanics;
};

export const resetMechanicsImplementation = (state) => {
  const { configuration } = state;
  configuration.configData.mechanics = DEFAULT_MECHANICS;
};

export const setDynamicsImplementation = (state, action) => {
  const { configuration } = state;
  const dynamics = action.payload;

  configuration.configData.dynamics = dynamics;
};

export const resetDynamicsImplementation = (state) => {
  const { configuration } = state;
  configuration.configData.dynamics = DEFAULT_DYNAMICS;
};

export const setDynamicsStepsImplementation = (state, action) => {
  const { configuration } = state;
  const dynamicsSteps = action.payload;

  configuration.configData.dynamics.steps = dynamicsSteps;
};

export const setDynamicsCycleRunningImplementation = (state, action) => {
  const { configuration } = state;
  const dynamicsCycleRunning = action.payload;

  configuration.configData.dynamics.cycleRunning = dynamicsCycleRunning;
};
